module.exports = __webpack_public_path__ + "cce8d2a3686e45fe87ad4629cf6b90aa.MP3";